import {addEventHandlers} from "./unload-blocker-event-handlers";

export const createUnloadBlockerStoreEnhancer = (options) =>
  (createStore) =>
    (...args) =>
      addEventHandlers(createStore(...args), options);
